<template>
    <div id="layout" :style="style">
        <slot/>
    </div>
</template>
<script>

export default {
    name: 'v-layout',
    props: {
        padding: {
            type: String,
            default: '10px'
        }
    },
    computed: {
        style () {
            return {
                padding: this.padding
            }
        }
    }
}
</script>

<style lang="less" scoped>
 #layout {
    height: 100%;
    // padding: 18px;
 }
</style>


// WEBPACK FOOTER //
// src/components/layouts/layout.vue